import React from "react";
import clsx from 'clsx';
import SelectProject from "../BreadcrumbComponents/SelectProject";
import ViewProjectQuality from "../BreadcrumbComponents/ViewProjectQuality";
import ViewDataModel from "../BreadcrumbComponents/ViewDataModel";
import ViewDataFlow from "../BreadcrumbComponents/ViewDataFlow";
import DesignView from "../BreadcrumbComponents/DesignView";

const QualityPageBreadcrumb = (props) => {


    const{
        selectedProject,
        setSelectedPage,
        setSelectedProject
    }= props;

    const changeProject = (option) => {
        
        let index = 0;

        JSON.parse(localStorage.getItem('data'))
        .forEach( (element, indexEl) => {
        if(element.name === option){
            index = indexEl;
        }
        }) 

        localStorage.setItem('selectedProject',index);
        localStorage.setItem('selectedPage',-1);
        setSelectedProject(index);
        setSelectedPage(-1);
    }

    return(
        <div style={{ backgroundColor: '#CFD8E0' }}>

            <div className={clsx('generalMarg','flexRowDirection')} style={{justifyContent: 'space-between'}}>
                <div className={clsx('flexRowDirection') } style={{width: '75%', padding: '0vw'}}>
                    <SelectProject
                        changeProject={changeProject}
                        selectedProject={selectedProject}
                    />
                </div>
                <div className={clsx('flexRowDirection')}>
                    <ViewDataModel/>
                    <ViewDataFlow/>
                    <ViewProjectQuality/>
                    <DesignView
                        selectedProject={selectedProject}
                    />
                </div>
            </div>
        </div>
    )

}

export default QualityPageBreadcrumb;